import React, { useRef } from 'react';
import { node, string, oneOfType, shape, func, any } from 'prop-types';
const canUseDOM = typeof window !== 'undefined';

/**
 * SSR component.
 *
 * This should be removed / updated in future or merged with StaticElement as effectively this
 * is put in place to render only on server so there is no duplication of script calls upon
 * re-render.
 */
const SsrScript = ({
  children,
  as,
  ref: givenRef,
  ...props
}) => {
  const ref = useRef(null);
  const isBrowser = SsrScript.canUseDOM;

  // We can't accept refs on this component as we use the created element's
  // ref to control the static content
  if (givenRef) {
    throw new Error('StaticContent does not accept refs');
  }

  // If we're on the server
  if (!isBrowser) {
    return /*#__PURE__*/React.createElement(as, props, children);
  }

  // Avoid re-render on the client
  return /*#__PURE__*/React.createElement(as, {
    ...props,
    ref,
    suppressHydrationWarning: true,
    dangerouslySetInnerHTML: {
      __html: ''
    }
  });
};
SsrScript.defaultProps = {
  children: null,
  as: 'div',
  ref: null
};
SsrScript.propTypes = process.env.NODE_ENV !== "production" ? {
  children: node,
  as: string,
  ref: oneOfType([func, shape({
    current: any
  })])
} : {};
// Patch canUseDOM for testing
SsrScript.canUseDOM = canUseDOM;
export default SsrScript;